import { render } from "./ImprevistosView.vue?vue&type=template&id=745b4986"
import script from "./ImprevistosView.vue?vue&type=script&lang=js"
export * from "./ImprevistosView.vue?vue&type=script&lang=js"

import "./ImprevistosView.vue?vue&type=style&index=0&id=745b4986&lang=css"

import exportComponent from "D:\\gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__